function close(e) {
  const lightboxId = $(e.currentTarget).data('lightboxid');
  const lightbox = $(`.lightbox-${lightboxId}`);
  const body = $('#body');

  // allow scrolling on homepage
  body.removeClass('v2-overflow-hidden');
  body.addClass('v2-overflow-auto');

  // hide lightbox
  lightbox.addClass('v2-hidden');
}

function open(e) {
  const lightbox = $(e.currentTarget);
  const body = $('#body');

  // prevent scrolling in background
  body.removeClass('v2-overflow-auto');
  body.addClass('v2-overflow-hidden');

  // display lightbox
  lightbox.removeClass('v2-hidden');
}

$(() => {
  const closeButtons = $('.lightbox-close-button');
  const lightboxes = $('.lightbox-container');

  closeButtons.on('click', (e) => close(e));
  lightboxes.on('open', (e) => open(e));
});
